<template>
    <v-dialog v-model="show" :content-class="''" :max-width="'1530px'" min-height="85%" max-height="85%"
        style="overflow-y: auto;">
        <v-row justify="center">
            <v-col md="8" class="pr-0">
                <v-carousel contain height="90vh" style="background: #202020;" hide-delimiter-background="true">
                    <v-carousel-item :aspect-ratio="1 / 1" class="" v-for="post in post.images" :key="post.id"
                        :src="`${$cloudFrontApi}${post.id}/STREAM_MERCHANT`" contain></v-carousel-item>
                </v-carousel>
                <!-- <v-carousel contain class="h-100">
                    <v-carousel-item :aspect-ratio="1 / 1" class="" v-for="post in post?.images"
                        :key="post.id" :src="`${$cloudFrontApi}${post.id}/STREAM_RETINA`" contain></v-carousel-item>
                </v-carousel> -->
                <v-responsive style="max-height: 100%; overflow: hidden;" class="h-100" max-height="100%"
                    :aspect-ratio="1 / 1" content-class="d-flex align-posts-center bg-black h-100">
                </v-responsive>
            </v-col>
            <v-col md="4" class="pl-0">
                <v-card class="w-100 d-flex flex-column" rounded="0" height="90vh" color="#f5f5f5">
                    <v-card-item class="company-post-dialog-title">
                        <v-list-item class="w-100 text-left px-0 " color="#ededed">
                            <template v-slot:prepend>
                                <v-avatar color="grey-darken-3 clickable" rounded="0" size="68"
                                    :image="`${$cloudFrontApi}${post?.merchant.avatar}/AVATAR`" @click="openProfile"></v-avatar>
                            </template>

                            <v-list-item-title class="mb-2 clickable" @click="openProfile">{{ post?.merchant.name
                                }}</v-list-item-title>

                            <v-list-item-subtitle>{{ post?.merchant.tagline }}</v-list-item-subtitle>
                        </v-list-item>
                    </v-card-item>
                    <v-card-text style="overflow-y: scroll;">
                        <div class="pa-4">
                            <!-- <div class="news-post-info d-flex justify-content-between">
                                <span>{{ post?.category }}</span>
    
                                <span class="post-start">{{ $getTimeDuration(post?.lastModified) }}</span>
                            </div> -->
                            <h4 class="my-2">{{ post?.headline }}</h4>
                            <p class="paragraphed-text">
                                {{ post?.text }}
                            </p>
                        </div>
                        <!-- <v-divider></v-divider> -->
                        <div class="py-3">
                            <b>{{ $t('fairling.profile.productHighlight.full.noMinimumOrder') }}</b>
                        </div>
                        <div class="py-3" v-if="post?.additionalInformation">
                            <b>{{ $t('fairling.profile.productHighlight.full.additionalInformation') }}</b><br>
                            {{ post?.additionalInformation }}
                        </div>
                        <!-- {{ post.labels }} -->
                        <CustomProductLabel v-for="label in post.labels" :key="label.id" :label="label"
                            @click="() => triggerOpenDiscoverPopup(label)" />
                    </v-card-text>
                    <!-- <v-card-actions class="mt-auto d-flex flex-column justify-text-left align-start">
                        <v-btn variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-cart-outline"
                            class="white--text mb-2" @click="reserve">zum
                            Onlineshop</v-btn>
                        <v-btn variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-mail"
                            class="white--text mb-2" @click="reserve">Geschäft kontaktieren</v-btn>
                        <v-btn variant="flat" size="large" color="primary" rounded="lg" prepend-icon="mdi-phone"
                            class="white--text mb-2" @click="reserve">Geschäft anrufen</v-btn>
                    </v-card-actions> -->
                </v-card>
            </v-col>
        </v-row>
    </v-dialog>
</template>


<script>
import CustomProductLabel from '@/components/custom/CustomProductLabel.vue';
export default {
    name: "CompanyPostDialog",

    components: {
        CustomProductLabel,
    },
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        post: {
            type: Object,
            required: true
        }
    },
    computed: {
        show: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },
    methods: {
        closeSheet() {
            this.show = false;
        },
        openProfile() {
            this.closeSheet();
            this.$router.push(`/fairling/${this.post.merchant.id}/${this.post.id}`)
            // this.$router.push(`/fairling/${this.item.merchant.id}/`);
        },
    },
};
</script>
<script setup>
import { ref, defineEmits, inject } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';

const openDiscoverPopup = inject('openDiscoverPopup');

const triggerOpenDiscoverPopup = (label) => {
    openDiscoverPopup(label);
}



 
</script>
<style scoped>
.company-post-dialog-title {
    background-color: #ededed;
}
</style>
